import AgGridWrapper from "../../../../../components/AgGridWrapper/AgGridWrapper";
import ActionButtons from "../../../../../components/ActionButtons";
import { changeStatus, setGrid } from "../../utils/slice";
import columnDefs from "./columnDefs";
import { useAppSelector } from "../../../../../utils/hooks/hooks";
import ConfirmModal from "../../../../../components/Modals/ConfirmModal";
import { useState } from "react";
import React from "react";

/**
 * Renders the Listing component  for career categories.
 *
 * @param {Object} props - The component props.
 * @param {Object} props.moduleInfo - The module information.
 * @param {Function} props.handleViewClick - The function to handle view click.
 * @param {Function} props.handleDeleteClick - The function to handle delete click.
 * @param {Function} props.handleEditClick - The function to handle edit click.
 * @return {JSX.Element} The rendered Listing component.
 */
const Listing: React.FC<any> = ({
  moduleInfo,
  handleViewClick,
  handleDeleteClick,
  handleEditClick,
}) => {
  const { careerCategories } = useAppSelector(state => state);
  const [statusData, setStatusData] = useState<any>();

  /**
   * Renders an ActionRenderer component for the ag grid contains the action buttons.
   */
  const ActionRenderer = (props: any) => {
    return (
      <ActionButtons
        data={props}
        view={{
          action: handleViewClick,
          permissionKey: `${moduleInfo.permissionKeyPrefix}_DETAILS`,
        }}
        edit={{
          action: handleEditClick,
          permissionKey: `${moduleInfo.permissionKeyPrefix}_UPDATE`,
        }}
        deleteButton={{
          action: handleDeleteClick,
          permissionKey: `${moduleInfo.permissionKeyPrefix}_DELETE`,
        }}
      />
    );
  };

  return (
    <>
      <ConfirmModal
        titleName={moduleInfo.title}
        data={statusData}
        close={() => setStatusData(null)}
        callApi={changeStatus}
      />
      <AgGridWrapper
        components={{
          ActionRenderer,
        }}
        rowData={careerCategories.rowData}
        onGridReadyWithDispatch={setGrid}
        columnDefs={columnDefs}
        context={{ setStatusData }}
        paginationPageSize={careerCategories.perPage}
        cacheBlockSize={careerCategories.perPage}
      />
    </>
  );
};

export default Listing;
